module.exports = __webpack_public_path__ + "static/media/tese_naiara.15b34137.png";